// removed by extract-text-webpack-plugin
module.exports = {"NavigationItems":"-name__-loca-___yd_d"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/NavigationItems/NavigationItems.css
// module id = 142
// module chunks = 0